import { ReactiveValue } from '@app/packages/reactives/ReactiveValue'

export type NetworkStateDescriptor = {
  online: boolean
}

export class NetworkStateTracker {
  readonly state = new ReactiveValue<NetworkStateDescriptor>({ online: false })
  private stack = new DisposableStack()

  constructor() {
    this.state.update(state => ({ ...state, online: window.navigator.onLine }))

    const handler = () => {
      this.state.update(state => ({ ...state, online: window.navigator.onLine }))
    }

    window.addEventListener('online', handler)
    this.stack.defer(() => window.removeEventListener('online', handler))
    window.addEventListener('offline', handler)
    this.stack.defer(() => window.removeEventListener('offline', handler))
  }

  [Symbol.dispose]() {
    this.stack.dispose()
  }
}
